import { createContext, useContext } from "react";
import { DateObject } from "react-multi-date-picker";

export const RouteProgressContext = createContext<DateObject[] | undefined>(
  undefined
);

export const useRouteProgressContext = () => {
  const dateRanges = useContext(RouteProgressContext);

  if (dateRanges === undefined) {
    throw new Error("Date ranges are empty");
  }
  return dateRanges;
};
